import {CognitoAuth} from 'amazon-cognito-auth-js';

// The session from the AWS Congito lib. Keep it private in the module.
var authSession;

// This will get called when session expires.
var sessionExpiredCallback = function() {};

var jwtRefreshTimer;

// These are responsible for optional session (max time, max inactive time)
var inactiveSessionTimeout;
var maxSessionTimeout;
var maxSessionTime; // in seconds
var maxInactiveTime; // in seconds

function setTokens(idToken, accessToken, refreshToken) {
	sessionStorage.setItem('jwt', idToken);
	sessionStorage.setItem('accessToken', accessToken);

	if(refreshToken) {
		sessionStorage.setItem('refreshToken', refreshToken);
	}
}
function decodeToken(token) {
	try {
		return JSON.parse(atob(token.split('.')[1]))
	}
	catch(err) {
		console.error(err);
		return {};
	}
}

function getUserInfo() {
	var jwt = sessionStorage.getItem('jwt');
	return jwt ? decodeToken(jwt) : {};
}


function clearTokens() {
	// remove the Cognito values
	var removeKeys = [];
	for (let i = 0; i < localStorage.length; i++) {
		var key = localStorage.key(i);
		if(key.indexOf('Cognito')==0) {
			removeKeys.push(key);
		}
	}
	for (let i = 0; i < removeKeys.length; i++) {
		localStorage.removeItem(removeKeys[i]);
	}
	sessionStorage.clear();
}


function onLogin(authSession) {
	var idToken = authSession.getIdToken().getJwtToken();
	// if(idToken) {
	// 	userInfo.idToken = decodeToken(idToken);
	// }
	var accessToken = authSession.getAccessToken().getJwtToken();
	// if(accessToken) {
	// 	userInfo.accessToken = decodeToken(accessToken);
	// }
	var refreshToken = authSession.getRefreshToken().getToken();

	setTokens(idToken, accessToken, refreshToken);

	document.location.href = '/';
}



function createAuthSession(config) {
	var authData = {
		ClientId : config.ClientId,
		RedirectUriSignIn : config.RedirectUriSignIn,
		RedirectUriSignOut : config.RedirectUriSignOut,
		AppWebDomain : config.AppWebDomain, // Exclude the "https://" part. 
		UserPoolId : config.UserPoolId, 
		TokenScopesArray : ['email', 'openid', 'profile'], // like ['openid','email','phone']...
		AdvancedSecurityDataCollectionFlag : false
	};

	var auth = new CognitoAuth(authData);
	// You can also set state parameter 
	// auth.setState(<state parameter>);  
	auth.userhandler = {
		onSuccess: onLogin,
		onFailure: function(err) {
			console.log("Login error", err);
			//alert("Login Error:" + err);
		}
	};
	// The default response_type is "token", uncomment the next line will make it be "code".
	auth.useCodeGrantFlow();
	return auth;
}


function refreshTokenCallback(response) {
	try {
		var data = JSON.parse(response);
		setTokens(data.id_token, data.access_token);
	}
	catch(err) {
		console.error("Could not parse refresh token response", err);
		clearTokens();
		sessionExpiredCallback(err);
	}
}

function onTokenFailure(response) {
	// alert("Your session has expired, please log back in.");
	console.error("Could not refresh JWT token", response);
	clearTokens();
	sessionExpiredCallback(response);
}

function setJwtRefreshTask() {
	authSession.onSuccessRefreshToken = refreshTokenCallback;
	authSession.onTokenFailure = onTokenFailure;

	// JWT expire after 1 hour, so set a 50 minute refresh interval
	var refreshInterval = 50*60*1000;
	var currentExpiry = 0;

	var info = getUserInfo();
	if(info && info.exp) {
		var jwtExpiry = info.exp*1000 - Date.now();
		console.log("JWT expires in (minutes)", jwtExpiry/(1000*60));
		currentExpiry = jwtExpiry - 5*60*1000; // subtract 5 minutes
		console.log("JWT refresh in (minutes)", currentExpiry/(1000*60));
	}

	if(currentExpiry<refreshInterval) {
		authSession.refreshSession(sessionStorage.getItem('refreshToken'));
	}

	jwtRefreshTimer = setInterval(function(){
		authSession.refreshSession(sessionStorage.getItem('refreshToken'));
	}, refreshInterval);
}

function clearSessionTimers() {
	clearInterval(jwtRefreshTimer);
	clearTimeout(maxSessionTimeout);
	clearTimeout(inactiveSessionTimeout);
}

function setInactiveTimer() {
	clearTimeout(inactiveSessionTimeout);

	if(maxInactiveTime) {
		inactiveSessionTimeout = setTimeout(function(){
			console.log('Max inactive time reached');
			clearSessionTimers();
			clearTokens();
			sessionExpiredCallback();
		}, maxInactiveTime*1000);
	}

}

/*
 Initializes the max session timer and inactive session timer.
 */
function initSessionTimers(maxTime, inactiveTime) {
	maxSessionTime = maxTime;
	maxInactiveTime = inactiveTime;

	if(maxSessionTime) {
		// test if the auth time is older than max session
		var info = getUserInfo();
		var sessionTime = maxSessionTime;
		if(info && info.auth_time) {
			var sessionAge = Date.now()/1000 - info.auth_time;
			sessionTime = maxSessionTime-sessionAge;
		}

		maxSessionTimeout = setTimeout(function() {
			console.log('Max session time reached');
			clearSessionTimers();
			clearTokens();
			sessionExpiredCallback();
		}, sessionTime*1000);
		console.log("Session expires in (minutes)", sessionTime/60);
	}
	setInactiveTimer();
}


export default {
	/*
	The config object must have these Cognito values:
		ClientId
		RedirectUriSignIn
		RedirectUriSignOut
		AppWebDomain
		UserPoolId
		IdentityProvider (optional)
	 */
	init: function(config) {
		authSession = createAuthSession(config);
		setJwtRefreshTask();
	},
	startSessionTimers: function(maxTime, inactiveTime) {
		initSessionTimers(maxTime, inactiveTime);
	},
	refreshToken: function(){
		authSession.refreshSession(sessionStorage.getItem('refreshToken'));
	},
	clearTokens: function(){
		clearTokens();
	},
	isLoggedIn: function() {
		return sessionStorage.getItem('jwt')!=null;
	},
	login: function() {
		clearTokens();
		authSession.getSession();
	},
	testLoginToken: function(url) {
		authSession.parseCognitoWebResponse(url);
	},
	logout: function() {
		clearTokens();
		authSession.signOut();
	},
	setSessionExpiredCallback: function(val) {
		sessionExpiredCallback = val;
	},

	// Call this funcion when user activity was noted, to extend the inactive session timer.
	userWasActive: function() {
		setInactiveTimer();
	},
	getUserInfo: function() {
		return getUserInfo();
	}
}